import { OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { VideoInfoModalService } from '@core/components/video-info-modal/video-info-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { TabLinksService } from '../../../dialog-create-maintenance/tabs/links/tab-links.service';
var TabLinksComponent = /** @class */ (function () {
    function TabLinksComponent(tabLinksService, translateService, videoInfoModalService) {
        this.tabLinksService = tabLinksService;
        this.translateService = translateService;
        this.videoInfoModalService = videoInfoModalService;
        this.hasLinkedItems = false;
        this.searchControl = new FormControl();
        this.locationLinks = [];
        this.unlinkedEquipments = [];
        this.destroy$ = new Subject();
    }
    TabLinksComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.populateLinkedItems();
        this.searchControl.valueChanges
            .pipe(takeUntil(this.destroy$), debounceTime(300))
            .subscribe(function () {
            _this.populateLinkedItems();
        });
        this.tabLinksService.reloadItem$
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (reloadItemSubject) {
            var items = _this.maintenance[reloadItemSubject.formControlName];
            var oldestItemToUpdateIndex = items.findIndex(function (item) { return item.id === reloadItemSubject.updatedValue.id; });
            items[oldestItemToUpdateIndex] = reloadItemSubject.updatedValue;
            _this.populateLinkedItems();
        });
    };
    TabLinksComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    TabLinksComponent.prototype.populateLinkedItems = function () {
        var equipments = this.maintenance.equipments || [];
        var sectors = this.maintenance.locationSectors || [];
        var environments = this.maintenance.locationEnvironments || [];
        this.hasLinkedItems = Boolean(environments.length ||
            equipments.length ||
            sectors.length);
        if (!this.hasLinkedItems) {
            return;
        }
        var _a = this.tabLinksService.linkSectorsEnvironmentsEquipments({
            sectors: sectors,
            environments: environments,
            equipments: equipments
        }), sectorsLinks = _a.sectors, unlinkedEquipments = _a.unlinkedEquipments;
        var locationLinksUnfiltered = this.tabLinksService.formatSectors({
            sectors: sectorsLinks,
            environments: environments,
            equipments: equipments,
            maintenance: this.maintenance
        });
        var unlinkedEquipmentsUnfiltered = this.tabLinksService.formatUnlinkedEquipments({
            unlinkedEquipments: unlinkedEquipments,
            maintenance: this.maintenance
        });
        this.locationLinks = this.filter(locationLinksUnfiltered, this.searchControl.value);
        this.unlinkedEquipments = this.filter(unlinkedEquipmentsUnfiltered, this.searchControl.value);
    };
    TabLinksComponent.prototype.filter = function (items, searchTerm) {
        var _this = this;
        searchTerm = (searchTerm || '').toLowerCase().trim();
        return items.filter(function (item) {
            if (item.children) {
                item.children = _this.filter(item.children, searchTerm);
            }
            var text = (item.text || '').toLowerCase();
            var description = (item.description || '').toLowerCase();
            return text.includes(searchTerm) || description.includes(searchTerm) || (item.children && item.children.length) || _this.parentMatch(item, searchTerm);
        });
    };
    TabLinksComponent.prototype.parentMatch = function (item, searchTerm) {
        if (!item.parent) {
            return false;
        }
        searchTerm = (searchTerm || '').toLowerCase().trim();
        var text = (item.parent.text || '').toLowerCase();
        var description = (item.parent.description || '').toLowerCase();
        return text.includes(searchTerm) || description.includes(searchTerm) || this.parentMatch(item.parent, searchTerm);
    };
    TabLinksComponent.prototype.openDemonstrationVideoDialog = function () {
        this.videoInfoModalService.open({
            title: this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.FEATURE.INTRO_VIDEO.TITLE'),
            description: this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.FEATURE.INTRO_VIDEO.DESCRIPTION'),
            videoId: 'VQE_FyV8Gf0'
        });
    };
    return TabLinksComponent;
}());
export { TabLinksComponent };
